
export const _INIT_INQUIRY_BOARD = '_INIT_INQUIRY_BOARD';

export const _CREATE_BOARD = '_CREATE_BOARD';

export const _GET_BOARD_INFO = '_GET_BOARD_INFO';

